const I = {
  key: Symbol("RADIO_GROUP_INJECTION_KEY")
};
export {
  I as R
};
//# sourceMappingURL=RadioGroup.keys-CqfiKkNz.js.map
